import { createAction } from "typesafe-actions";
import * as types from "./types";

export const requestError = createAction(types.REQUEST_ERROR)<string>();
